class ChartOptions {
  constructor(model = {}) {

  }

  static getChartOptions({label, value, color}) {
    
    
    let perc = 0

    let rest = 0

    if(value < 100){
      rest = 100 - value
    } else{
      if(value < 1000){
        rest = 1000 - value
      } else{
        if(value < 10000){
          rest = 10000 - value
        } else{
          if(value < 100000){
            rest = 100000 - value
          }
        }
      }
    }

    
    let opt = {
      title: {
        text: value,
        subtext: label,
        left: 'center',
        top: 'center',
        textStyle: {
          fontSize: 14,
          color: '#666'
        },
        subtextStyle: {
          fontSize: 9,
          color: '#666'
        }
      },
      series: [
        {
          name: 'Half Doughnut',
          type: 'pie',
          radius: ['50%', '70%'],
          startAngle: 90,
          labelLine: { show: false },
          label: { show: false },
          data: [
            { value: value, name: label, itemStyle: { color: color } },
            { value: rest, name: 'Rest', itemStyle: { color: 'transparent' } } // Invisible part
          ]
        }
      ]
    }

    return opt
  }
}